import React from 'react';
import './WorkingModelSection.css';

const WorkingModelSection = () => {
  return (
    <section className="working-model-section" id = "working-model">
      <div className="container">
      <div className="top-content">
        <h2>
          HOW WE <span className="blue-text"><br/>WORK</span>
        </h2>
        <p>
          We provide you with flexible solutions throughout the software development lifecycle, from expanding your delivery team to full project management, depending on your requirements.
        </p>
      </div>

      <div className="card-row">
        <div className="model-card">
          <div className="card-header">
            <img src="/men.webp" alt="logo" />
            <h3>MANAGED TEAMS</h3>
          </div>
          <p>
            We provide you with a web design and development squad or an individual fit to your needs, able to work independently, and/or fully integrated within your delivery team and processes.
          </p>
        </div>

        <div className="model-card">
          <div className="card-header">
            <img src="/setting.webp" alt="logo" />
            <h3>MANAGED PROJECT</h3>
          </div>
          <p>
            We will develop the project in-house, following our battle-tested processes which ensure world-class quality and efficiency. This end-to-end solution is ideal for companies without internal technical teams.
          </p>
        </div>
      </div>

      
      </div>
    </section>
  );
};

export default WorkingModelSection;
